import React from "react";

import { Button } from "../../../../../components/button";
import { Input } from "../../../../../components/input";
import { Label } from "../../../../../components/label";
import { MultiSelectV2 } from "../../../../../components/multi-select-v2";
import { SelectV2 } from "../../../../../components/select-v2";
import {
  FILE_UPLOAD_FORMAT_OPTIONS,
  FILE_UPLOAD_SIZE_OPTIONS,
} from "../../../data/fileUpload.constants";
import type { QuestionTypeRendererProps } from "./shared";

export function FileUploadQuestion({
  question,
  isPreview,
  onUpdateQuestion,
}: QuestionTypeRendererProps<"file_upload">) {
  const { data } = question;
  const updateQuestionData = (updates: Partial<typeof data>) => {
    onUpdateQuestion({
      ...question,
      data: {
        ...data,
        ...updates,
      },
    });
  };

  if (isPreview) {
    return (
      <Button
        variant="outline"
        disabled
      >
        Choose File
      </Button>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <Label>Max file size</Label>
        <SelectV2
          value={String(data.max_file_size ?? 5242880)}
          onChange={(value) => updateQuestionData({ max_file_size: Number(value) })}
          options={FILE_UPLOAD_SIZE_OPTIONS}
          placeholder="Select max file size"
          ariaLabel="Max file size"
          className="mt-1"
        />
      </div>
      <div>
        <Label>Allowed formats</Label>
        <MultiSelectV2
          value={data.allowed_formats ?? []}
          onChange={(allowedFormats) => updateQuestionData({ allowed_formats: allowedFormats })}
          onClear={() => updateQuestionData({ allowed_formats: [] })}
          options={FILE_UPLOAD_FORMAT_OPTIONS}
          placeholder="Select allowed formats"
          ariaLabel="Allowed formats"
          className="mt-1"
        />
      </div>
      <div>
        <Label>Max files</Label>
        <Input
          type="number"
          value={data.max_files || 1}
          onChange={(e) =>
            updateQuestionData({ max_files: Number.parseInt(e.target.value, 10) || 1 })
          }
          className="mt-1"
        />
      </div>
    </div>
  );
}

export default FileUploadQuestion;
